import CampaignGrid from '../shared/components/grid/CampaignGrid'
import {useState, useEffect} from 'react'
import * as label from '../../shared/util/label'
import * as constant from '../../shared/util/constant'

// Placeholder rows until the Campaign WorkFlow API/DB is wired up.
const placeholderWorkFlows = [
  {
    campaignId: 0,
    campaignName: 'Sample WorkFlow 1',
    templateTypeName: 'Email',
    categoryName: 'Renewal',
    status: constant.SAVED,
    sentDate: '',
    changedDate: '',
    changedBy: '',
    resultCount: 0,
    queryId: 0,
    queryName: '',
    queryInactive: false,
    templateId: 0,
    templateName: '',
    templateInactive: false,
    isSendOnBlackoutDate: false
  },
  {
    campaignId: 0,
    campaignName: 'Sample WorkFlow 2',
    templateTypeName: 'Email',
    categoryName: 'Cross Sell',
    status: constant.SAVED,
    sentDate: '',
    changedDate: '',
    changedBy: '',
    resultCount: 0,
    queryId: 0,
    queryName: '',
    queryInactive: false,
    templateId: 0,
    templateName: '',
    templateInactive: false,
    isSendOnBlackoutDate: false
  }
]

const CampaignWorkFlowList = () => {
    const [data, setData] = useState([]);
    const [showFilters,setShowFilters] = useState(true);

      // No API call yet - load the placeholder rows so the grid renders.
      useEffect(() => {
        setData(placeholderWorkFlows as any);
      },[]);

    return(
      <div>
        <CampaignGrid
        data={data!=undefined?data:""}
        showFilters={showFilters}
        gridHeader={label.CAMPAIGN_WORKFLOWS}
        hiddenColumns={['campaignId', 'selection']}
        includeInactiveLabel={label.INCLUDE_INACTIVE_CAMPAIGN_WORKFLOWS}
        newButtonLabel={label.NEW_CAMPAIGN_WORKFLOW}
        newButtonPath={'/Campaign/CampaignWorkFlowDetail'}
        detailPath={'/Campaign/CampaignWorkFlowDetail'}
        detailMenuName={'CampaignWorkFlows'}
        />
      </div>
   )
    }
export default CampaignWorkFlowList
